// extracted by mini-css-extract-plugin
export default {"toppings":"burger-constructor-toppings-list_toppings__cNv+I"};